export type AccountAuthBuildEnv = {
  VITE_SUPABASE_URL?: string;
  VITE_SUPABASE_PUBLISHABLE_KEY?: string;
  VITE_SUPABASE_ANON_KEY?: string;
};

// These are browser-safe Supabase publishable credentials. Build variables can
// override them for local or non-production projects without breaking the
// Cloudflare automatic production build when its env is not populated.
const DEFAULT_SUPABASE_URL = "https://acemtirrhlglrprkrxjn.supabase.co";
const DEFAULT_SUPABASE_PUBLISHABLE_KEY = "sb_publishable_e0YsGOXfHTT3eyH_hzCITA_CYLgq4gb";

const trim = (value: string | undefined): string => value?.trim() ?? "";

export const resolveAccountAuthConfig = (env: AccountAuthBuildEnv) => ({
  supabaseUrl: trim(env.VITE_SUPABASE_URL) || DEFAULT_SUPABASE_URL,
  supabaseKey:
    trim(env.VITE_SUPABASE_PUBLISHABLE_KEY) ||
    trim(env.VITE_SUPABASE_ANON_KEY) ||
    DEFAULT_SUPABASE_PUBLISHABLE_KEY
});
